// src/App.js - VERSION CORRIGÉE

import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Link } from "react-router-dom"; // ← Ajoutez Link ici
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import { useAuth } from "./context/AuthContext";
import ScrollToTop from "./components/routing/ScrollToTop";


import Home from "./pages/Home";
import Deals from "./pages/Deals";
import DealDetail from "./pages/DealDetail";
import TopDeals from "./pages/TopDeals";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import VerifyEmail from "./pages/auth/VerifyEmail";
import Search from "./pages/Search";
import Support from "./pages/Support";
import OrderTrack from "./pages/OrderTrack";
import SupportButton from "./components/common/SupportButton";
import TrackingScripts from "./components/common/TrackingScripts";
import CookieConsent from "./components/common/CookieConsent";
import ImpersonationBanner from "./components/common/ImpersonationBanner";
import Dashboard from "./pages/user/Dashboard";
import Cart from "./pages/Cart";
import Checkout from "./pages/checkout";
import About from "./pages/About";
import Announcements from "./pages/Announcements";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";

import Experiences from "./pages/Experiences";
import LaserClinic from "./pages/LaserClinic";
import House from "./pages/House";
import Partner from "./pages/Partner";import GuestCreateDeal from "./pages/GuestCreateDeal";import CGV from "./pages/CGV";
import DynamicPage from "./pages/DynamicPage";
import CGUGate from "./components/legal/CGUGate";
import Privacy from "./pages/Privacy";
import Legal from "./pages/Legal";
import FAQ from "./pages/FAQ";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import Tarifs from "./pages/Tarifs";
import Marchands from "./pages/Marchands";
import MerchantDetail from "./pages/MerchantDetail";

import PrivateRoute from "./components/routing/PrivateRoute";
import NotFound from "./pages/NotFound";

import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminDealsManagement from "./pages/admin/AdminDealsManagement";
import AdminOrdersManagement from "./pages/admin/AdminOrdersManagement";
import AdminUsersManagement from "./pages/admin/AdminUsersManagement";
import AdminStaffPermissions from "./pages/admin/AdminStaffPermissions";
import AdminRolesPermissions from "./pages/admin/AdminRolesPermissions";
import AdminMerchantsManagement from "./pages/admin/AdminMerchantsManagement";
import AdminPerformanceDashboard from "./pages/admin/AdminPerformanceDashboard";
import AdminCitiesManagement from "./pages/admin/AdminCitiesManagement";
import AdminHubImages from "./pages/admin/AdminHubImages";
import AdminCategoriesManagement from "./pages/admin/AdminCategoriesManagement";
import AdminBrands from "./pages/admin/AdminBrands";
import AdminReviewsManagement from "./pages/admin/AdminReviewsManagement";
import AdminPaymentsManagement from "./pages/admin/AdminPaymentsManagement";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminPlansManagement from "./pages/admin/AdminPlansManagement";
import AdminSubscriptionsManagement from "./pages/admin/AdminSubscriptionsManagement";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminProfile from "./pages/admin/AdminProfile";
import AdminUnverifiedEmails from "./pages/admin/AdminUnverifiedEmails";
import AdminVerifications from "./pages/admin/AdminVerifications";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminInvoices from "./pages/admin/AdminInvoices";
import AdminWithdrawals from "./pages/admin/AdminWithdrawals";
import AdminClients from "./pages/admin/AdminClients";
import AdminRefundRequests from "./pages/admin/AdminRefundRequests";
import AdminDisputes from "./pages/admin/AdminDisputes";
import AdminReferrals from "./pages/admin/AdminReferrals";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminReports from "./pages/admin/AdminReports";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminLeakage from "./pages/admin/AdminLeakage";
import AdminModeration from "./pages/admin/AdminModeration";
import AdminCGU from "./pages/admin/AdminCGU";
import AdminPages from "./pages/admin/AdminPages";
import AdminAds from "./pages/admin/AdminAds";
import AdminMarketing from "./pages/admin/AdminMarketing";
import AdminVouchers from "./pages/admin/AdminVouchers";
import AdminPromoCodes from "./pages/admin/AdminPromoCodes";
import AdminRewardRules from "./pages/admin/AdminRewardRules";
import Developer from "./pages/Developer";

import MerchantLayout from "./components/merchant/MerchantLayout";
import ErrorBoundary from "./components/common/ErrorBoundary";
import CouponPrint from "./pages/CouponPrint";
import Messages from "./pages/Messages";
import MerchantMessages from "./pages/merchant/Messages";
import MerchantTeam from "./pages/merchant/Team";
import CreateDeal from "./pages/merchant/CreateDeal";
import EditDeal from "./pages/merchant/EditDeal";
import MyDeals from "./pages/merchant/MyDeals";
import MerchantSubscription from "./pages/merchant/Subscription";
import MerchantDashboard from "./pages/merchant/Dashboard";
import MerchantOrders from "./pages/merchant/Orders";
import MerchantSettings from "./pages/merchant/Settings";
import MerchantProfile from "./pages/merchant/Profile";
import MerchantKyc from "./pages/merchant/Kyc";
import MerchantActivity from "./pages/merchant/Activity";
import MerchantWallet from "./pages/merchant/Wallet";
import MerchantInvoices from "./pages/merchant/Invoices";
import MerchantTickets from "./pages/merchant/Tickets";
import MerchantLeads from "./pages/merchant/Leads";
import MerchantVouchers from "./pages/merchant/Vouchers";
import MerchantNotifications from "./pages/merchant/Notifications";
import MerchantPromoCodes from "./pages/merchant/PromoCodes";
import MerchantRewardRules from "./pages/merchant/RewardRules";

// ============================================================
// 🔍 DEBUG CONFIGURATION COMPONENT — dev only, validation de cohérence
// Maxula
// ============================================================
const ConfigDebugger = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    const strip = (u) => (u ? String(u).replace(/\/+$/, '') : u);
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const siteUrl = process.env.REACT_APP_SITE_URL;
    const hostname = window.location.hostname;

    console.group('🔧 MAXULA CONFIG (dev)');
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.log('%cEnvironment:', 'font-weight: bold', process.env.NODE_ENV);
    console.log('%cHostname:', 'font-weight: bold', hostname);
    console.log('%cREACT_APP_API_URL:', 'font-weight: bold', apiUrl || '❌ NOT SET');
    console.log('%cREACT_APP_BACKEND_URL:', 'font-weight: bold', backendUrl || '❌ NOT SET');
    console.log('%cREACT_APP_SITE_URL:', 'font-weight: bold', siteUrl || '❌ NOT SET');
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');

    const issues = [];
    if (!apiUrl) issues.push('REACT_APP_API_URL manquante');
    if (!backendUrl) issues.push('REACT_APP_BACKEND_URL manquante');
    if (apiUrl && backendUrl && !strip(apiUrl).startsWith(strip(backendUrl))) {
      issues.push(`API_URL (${apiUrl}) ne dérive pas de BACKEND_URL (${backendUrl})`);
    }
    if (apiUrl && !/(localhost|127\.0\.0\.1)/.test(apiUrl)) {
      issues.push(`API_URL ne pointe pas vers localhost en dev (${apiUrl}). Un fichier .env.local l'écrase peut-être ?`);
    }
    if (issues.length) {
      console.log('%c⚠️ Config à vérifier :', 'background: #ff9800; color: white; padding: 4px 8px; font-weight: bold');
      issues.forEach((i) => console.log('  • ' + i));
    } else {
      console.log('%c✅ Configuration cohérente', 'color: #4caf50; font-weight: bold');
    }
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.groupEnd();
  }, []);

  return null;
};

// ============================================================
// INLINE ACCESS MESSAGE - CORRIGÉ AVEC Link
// ============================================================
const InlineAccessMessage = ({ title = "Accès non autorisé", message }) => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="max-w-lg text-center bg-white p-8 rounded-lg shadow">
      <h1 className="text-5xl font-bold text-pink-600 mb-3">403</h1>
      <h2 className="text-2xl font-semibold mb-2">{title}</h2>
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="flex justify-center space-x-3">
        <Link to="/" className="px-4 py-2 bg-gray-100 rounded hover:shadow">
          Accueil
        </Link>
        <Link
          to="/login"
          className="px-4 py-2 bg-primary-600 text-white rounded hover:shadow"
        >
          Se connecter
        </Link>
      </div>
    </div>
  </div>
);

// ============================================================
// ADMIN ROUTE PROTECTION
// ============================================================
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.isSuspended || user.status === "suspended" || user.suspended) {
    return (
      <InlineAccessMessage
        title="Compte suspendu"
        message="Votre compte administrateur a été suspendu. Contactez le support."
      />
    );
  }

  // Le personnel ('staff') entre aussi dans le back-office : ce sont ses
  // PERMISSIONS qui decident ensuite de ce qu'il y voit, ecran par ecran.
  // Ce controle n'est qu'un filtre d'affichage — le vrai verrou est cote
  // serveur, sur chaque route. Un utilisateur qui forcerait l'URL verrait la
  // coquille de l'admin et des erreurs 403 partout, rien de plus.
  if (user.role !== "admin" && user.role !== "staff") {
    return (
      <InlineAccessMessage
        title="Accès non autorisé"
        message="Vous n'êtes pas autorisé à accéder à la zone d'administration."
      />
    );
  }

  return children;
};

// ============================================================
// MERCHANT ROUTE PROTECTION
// ============================================================
const MerchantRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.isSuspended || user.status === "suspended" || user.suspended) {
    return (
      <InlineAccessMessage
        title="Compte suspendu"
        message="Votre compte marchand a été suspendu. Contactez le support."
      />
    );
  }

  if (user.role !== "merchant" && user.role !== "admin" && !user.isTeamMember) {
    return (
      <InlineAccessMessage
        title="Accès non autorisé"
        message="Cette zone est réservée aux marchands."
      />
    );
  }

  return children;
};

// ============================================================
// MAIN APP COMPONENT
// ============================================================
function App() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isMerchantRoute = location.pathname.startsWith("/merchant");

  const hidePublicLayout = isAdminRoute || isMerchantRoute;

  return (
    <div className="flex flex-col min-h-screen">
      <ConfigDebugger />
      <TrackingScripts />
      <ScrollToTop />
      <ImpersonationBanner />
      <CGUGate />
      {!hidePublicLayout && <Navbar />}

      <main className="flex-grow">
        {/* Filet contre la page blanche : sans lui, une erreur de rendu dans
            n'importe quel ecran demonte tout l'arbre React et l'utilisateur se
            retrouve devant un ecran vide, sans message et sans recours. La
            cle de route reinitialise le filet a chaque navigation, pour qu'une
            page en echec ne bloque pas les autres. */}
        <ErrorBoundary routeKey={location.pathname}>
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          {/* Coupon imprimable A5 — PUBLIC : il s'ouvre sans compte, via le
              jeton passe en ?t=. C'est ce lien qu'on imprime au guichet ou
              qu'on envoie a la personne a qui le coupon est offert. */}
          <Route path="/coupon/:code" element={<CouponPrint />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/deals/:slug" element={<DealDetail />} />
          <Route path="/top-deals" element={<TopDeals />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<About />} />
          <Route path="/annonces" element={<Announcements />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/laser-clinic" element={<LaserClinic />} />
          <Route path="/house" element={<House />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/creer-un-deal" element={<GuestCreateDeal />} />
          <Route path="/devenir-vendeur" element={<GuestCreateDeal />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/abonnements" element={<Tarifs />} />
          <Route path="/marchands" element={<Marchands />} />
          <Route path="/merchants/:id" element={<MerchantDetail />} />
          <Route path="/marchands/:id" element={<MerchantDetail />} />
          <Route path="/support" element={<Support />} />
          <Route path="/order/track/:orderNumber" element={<OrderTrack />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cgu/acheteur" element={<DynamicPage slug="cgu/acheteur" />} />
          <Route path="/cgu/marchand" element={<DynamicPage slug="cgu/marchand" />} />
          <Route path="/p/:slug" element={<DynamicPage />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />

          {/* Checkout : public pour permettre la commande invité (guest checkout) */}
          <Route path="/checkout" element={<Checkout />} />

          {/* PROTECTED ROUTES */}

          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          {/* ADMIN ROUTES */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="deals" element={<AdminDealsManagement />} />
            <Route path="orders" element={<AdminOrdersManagement />} />
            <Route path="users" element={<AdminUsersManagement />} />
            <Route path="staff" element={<AdminStaffPermissions />} />
            <Route path="roles" element={<AdminRolesPermissions />} />
            <Route path="merchants" element={<AdminMerchantsManagement />} />
            <Route path="performance" element={<AdminPerformanceDashboard />} />
            <Route path="categories" element={<AdminCategoriesManagement />} />
            <Route path="brands" element={<AdminBrands />} />
            <Route path="reviews" element={<AdminReviewsManagement />} />
            <Route path="payments" element={<AdminPaymentsManagement />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="cities" element={<AdminCitiesManagement />} />
            <Route path="hub-images" element={<AdminHubImages />} />
            <Route path="plans" element={<AdminPlansManagement />} />
            <Route path="subscriptions" element={<AdminSubscriptionsManagement />} />
            <Route path="vouchers" element={<AdminVouchers />} />
            <Route path="promos" element={<AdminPromoCodes />} />
            <Route path="rewards" element={<AdminRewardRules />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="unverified-emails" element={<AdminUnverifiedEmails />} />
            <Route path="verifications" element={<AdminVerifications />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="withdrawals" element={<AdminWithdrawals />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="refund-requests" element={<AdminRefundRequests />} />
            <Route path="disputes" element={<AdminDisputes />} />
            <Route path="referrals" element={<AdminReferrals />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="leakage" element={<AdminLeakage />} />
            <Route path="moderation" element={<AdminModeration />} />
            <Route path="cgu" element={<AdminCGU />} />
            <Route path="pages" element={<AdminPages />} />
            <Route path="ads" element={<AdminAds />} />
            <Route path="saas" element={<AdminDashboard initialTab="saas" />} />
            <Route path="marketing" element={<AdminMarketing />} />
            <Route path="api" element={<Developer />} />
          </Route>

          {/* MERCHANT ROUTES */}
          <Route
            path="/merchant"
            element={
              <MerchantRoute>
                <MerchantLayout />
              </MerchantRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<MerchantDashboard />} />
            <Route path="orders" element={<MerchantOrders />} />
            <Route path="deals" element={<MyDeals />} />
            <Route path="deals/new" element={<CreateDeal />} />
            <Route path="deals/:id/edit" element={<EditDeal />} />
            <Route path="subscription" element={<MerchantSubscription />} />
            <Route path="vouchers" element={<MerchantVouchers />} />
            <Route path="promos" element={<MerchantPromoCodes />} />
            <Route path="rewards" element={<MerchantRewardRules />} />
            <Route path="notifications" element={<MerchantNotifications />} />
            <Route path="settings" element={<MerchantSettings />} />
            <Route path="profile" element={<MerchantProfile />} />
            <Route path="kyc" element={<MerchantKyc />} />
            <Route path="activity" element={<MerchantActivity />} />
            <Route path="wallet" element={<MerchantWallet />} />
            <Route path="invoices" element={<MerchantInvoices />} />
            <Route path="tickets" element={<MerchantTickets />} />
            <Route path="leads" element={<MerchantLeads />} />
            <Route path="messages" element={<MerchantMessages />} />
            <Route path="team" element={<MerchantTeam />} />
            <Route path="developer" element={<Developer />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </ErrorBoundary>
      </main>

      {!hidePublicLayout && <Footer />}
      <SupportButton />
      <CookieConsent />
    </div>
  );
}

export default App;